import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LangContext";
import api from "@/lib/api";
import { toast } from "sonner";

const Newsletter = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email, website });
      if (data.status === "already_subscribed") toast(t("home.newsletter.already"));
      else toast.success(t("home.newsletter.success"));
      setEmail("");
    } catch {
      toast.error("Error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="bg-bone border-t border-stone-200">
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32 text-center">
        <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-charcoal">{t("home.newsletter.title")}</h2>
        <p className="text-stone-500 mt-4 max-w-lg mx-auto">{t("home.newsletter.subtitle")}</p>
        <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input type="text" name="website" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
          <Input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("home.newsletter.placeholder")}
            data-testid="newsletter-email"
            className="rounded-none border-stone-300 bg-white h-12 focus-visible:ring-1 focus-visible:ring-charcoal"
          />
          <Button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="rounded-none bg-charcoal text-white hover:bg-stone-800 h-12 px-8 text-xs uppercase tracking-[0.2em]"
          >
            {t("home.newsletter.cta")}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
